export default "__VITE_PUBLIC_ASSET__921ddc63__"